import React from 'react'
import styled from 'styled-components'
import { pick } from 'ramda'
import EmailAndSocial from './EmailAndSocial'
import PhoneNumbers from './PhoneNumbers'
import { InfoWrapper } from '../shared'

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  @media screen and (max-width: 767.98px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const hasPhoneNumbers = data => !!(data.publicPhone || data.publicMobile)

export const getPhoneNumbers = pick(['publicMobile', 'publicPhone'])

export default ({ data }) => (
  <Wrapper>
    <InfoWrapper>
      <EmailAndSocial data={data} />
    </InfoWrapper>
    {
      hasPhoneNumbers(data) && <InfoWrapper>
        <PhoneNumbers numbers={getPhoneNumbers(data)} />
      </InfoWrapper>
    }
  </Wrapper>
)
